const currentDate = new Date()

export const isEventInFuture = (start: string) => {
  const startAsDate = new Date(start)
  return startAsDate > currentDate
}
